import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { DisplayedCollection } from "../../app/backendTypes";
import { useAppSelector, useCollection, useUser } from "../../app/hooks";
import { RemoveCollection } from "./RemoveCollection";
import { SetCollection } from "./SetCollection";
import DatasetsAccess from "./DatasetsAccess";
import Avatar from "../common/Avatar";

export default function CollectionComponent(props: {
  displayedCollection: DisplayedCollection;
  callback: () => void;
  isAdmin: boolean;
}) {
  const { displayedCollection, callback, isAdmin } = props;

  const { collection, reload } = useCollection(
    displayedCollection.id,
    !isAdmin
  );

  const userId = useAppSelector((state) => state.auth.userId);
  const { user } = useUser(userId);

  return (
    <>
      {isAdmin && collection !== null && (
        <Box sx={{ display: "flex", gap: 2 }}>
          <SetCollection
            callback={() => {
              reload();
              callback();
            }}
            values={collection}
          />
          <RemoveCollection collection={collection} callback={callback} />
        </Box>
      )}

      <Box sx={{ display: "flex", gap: 2 }}>
        <Avatar
          alt={displayedCollection.info.display_name}
          src={displayedCollection.info.avatar}
        />
        <Typography variant="h4">
          {displayedCollection.info.display_name}
        </Typography>
      </Box>

      <Card sx={{ width: "100%", maxWidth: "sm" }}>
        <CardHeader
          title={displayedCollection.info.short_desc}
          slotProps={{ title: { color: "primary" } }}
        />
        <CardContent>
          <Typography>{displayedCollection.info.long_desc}</Typography>
          {user !== null && (
            <>
              <br />
              <DatasetsAccess
                displayedCollection={displayedCollection}
                user={user}
              />
            </>
          )}
        </CardContent>
      </Card>
    </>
  );
}
